import { render, staticRenderFns } from "./studentLeaveDetail.vue?vue&type=template&id=22a48801&scoped=true&"
import script from "./studentLeaveDetail.vue?vue&type=script&lang=js&"
export * from "./studentLeaveDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentLeaveDetail.vue?vue&type=style&index=0&id=22a48801&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a48801",
  null
  
)

export default component.exports